export default {
  async GET_TABLE(state, payload) {
    // payload.column.push({
    //   headerName: "",
    //   field: "more",
    //   width: 200,
    //   filter: true,
    //   cellRendererFramework: "More",
    // });
    // let more = [
    //   {
    //     name: "ส่งอีเมลล์",
    //     value: "api.hod.tech/send_email",
    //     menu_type: "Email",
    //   },
    //   {
    //     name: "แก้ไขใบแจ้งหนี้",
    //     value: "1",
    //     menu_type: "Invoice",
    //   },
    //   {
    //     name: "เพิ่มเอกสารแนบ",
    //     value: "page/import", //path of import page
    //     menu_type: "Document",
    //   },
    //   {
    //     name: "ดาวน์โหลด",
    //     value: "api.hod.tech/file",
    //     menu_type: "Download",
    //   },
    //   {
    //     name: "ลบ",
    //     value: "2", // id_user,
    //     menu_type: "Delete",
    //   },
    // ];
    // let ddata = payload.data;
    // for await (const index of ddata) {
    //   index.more = more;
    //   console.log("index", index);
    // }
    // console.log("moremoremore", payload.data);
    state.table = payload;
  },
  GET_SUB_TABLE(state, payload) {
    state.subTable = payload;
  },
  CHANGE_SUB_TABLE(state, payload) {
    console.log(state.subTable);
    state.subTable.data.push(payload);
  },
  GET_TAB(state, payload) {
    state.tab = payload;
  },
  GET_RENDER_DETAIL(state, payload) {
    state.renderDetail = payload;
  },
  GET_DETAIL_DATA(state, payload) {
    state.detailData = payload;
  },
  GET_TAB_ACTIVE(state, payload) {
    state.tabActive = payload;
  },
  GET_ID_USER(state, payload) {
    state.id_user = payload;
  },
};
